module.exports = __webpack_public_path__ + "media/images/close-0cfd6489.png";